import { useTranslation } from "react-i18next";
import type { ContractApprovalStatusNotification } from "@/gql/graphql";
import DataListItemText from "./DataListItemText";

type ApprovalRequestNotificationProps = {
  data: ContractApprovalStatusNotification;
};

type ApprovalRequestVariantKey =
  | "discount_approved"
  | "discount_rejected"
  | "discount_approved_amendment"
  | "discount_rejected_amendment"
  | "billing_frequency_approved"
  | "billing_frequency_rejected";

const ApprovalRequestNotification = (
  props: ApprovalRequestNotificationProps
) => {
  const { data } = props;
  const { t } = useTranslation();
  const {
    contractNumber,
    approvalStatus,
    approvalRequestType,
    amendmentQuoteId,
  } = data;
  if (!approvalStatus || !approvalRequestType) {
    return null;
  }

  const statusKey = approvalStatus.toLowerCase();
  const requestTypeKey = approvalRequestType.toLowerCase();
  const notificationKey = `${requestTypeKey}_${statusKey}`;
  const variantKey = (
    amendmentQuoteId ? `${notificationKey}_amendment` : notificationKey
  ) as ApprovalRequestVariantKey;
  return (
    <DataListItemText
      primary={t(`notifications.approval_request.${variantKey}.title`, {
        contractNumber,
        amendmentQuoteId,
      })}
      secondary={t(`notifications.approval_request.${variantKey}.description`)}
    />
  );
};

export default ApprovalRequestNotification;
